// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/connections/public/v1/commands_api.proto (package gdx.connections.public.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AcceptPowerLikeCommandRequest, AcceptPowerLikeCommandResponse, BlockUserCommandRequest, BlockUserCommandResponse, CancelPowerLikeCommandRequest, CancelPowerLikeCommandResponse, ClearDialogCommandRequest, ClearDialogCommandResponse, DeleteMessagesCommandRequest, DeleteMessagesCommandResponse, MakeDialogReadCommandRequest, MakeDialogReadCommandResponse, RemoveDialogsCommandRequest, RemoveDialogsCommandResponse, ReportUserCommandRequest, ReportUserCommandResponse, RequestPhotoCommandRequest, RequestPhotoCommandResponse, SendLikeCommandRequest, SendLikeCommandResponse, SendMessageCommandRequest, SendMessageCommandResponse, SendPowerLikeCommandRequest, SendPowerLikeCommandResponse, UnblockUserCommandRequest, UnblockUserCommandResponse } from "./commands_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gdx.connections.public.v1.CommandsAPIService
 */
export const CommandsAPIService = {
  typeName: "gdx.connections.public.v1.CommandsAPIService",
  methods: {
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.SendLikeCommand
     */
    sendLikeCommand: {
      name: "SendLikeCommand",
      I: SendLikeCommandRequest,
      O: SendLikeCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.SendPowerLikeCommand
     */
    sendPowerLikeCommand: {
      name: "SendPowerLikeCommand",
      I: SendPowerLikeCommandRequest,
      O: SendPowerLikeCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.AcceptPowerLikeCommand
     */
    acceptPowerLikeCommand: {
      name: "AcceptPowerLikeCommand",
      I: AcceptPowerLikeCommandRequest,
      O: AcceptPowerLikeCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.CancelPowerLikeCommand
     */
    cancelPowerLikeCommand: {
      name: "CancelPowerLikeCommand",
      I: CancelPowerLikeCommandRequest,
      O: CancelPowerLikeCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.BlockUserCommand
     */
    blockUserCommand: {
      name: "BlockUserCommand",
      I: BlockUserCommandRequest,
      O: BlockUserCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.UnblockUserCommand
     */
    unblockUserCommand: {
      name: "UnblockUserCommand",
      I: UnblockUserCommandRequest,
      O: UnblockUserCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.ReportUserCommand
     */
    reportUserCommand: {
      name: "ReportUserCommand",
      I: ReportUserCommandRequest,
      O: ReportUserCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.ClearDialogCommand
     */
    clearDialogCommand: {
      name: "ClearDialogCommand",
      I: ClearDialogCommandRequest,
      O: ClearDialogCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.RemoveDialogsCommand
     */
    removeDialogsCommand: {
      name: "RemoveDialogsCommand",
      I: RemoveDialogsCommandRequest,
      O: RemoveDialogsCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.SendMessageCommand
     */
    sendMessageCommand: {
      name: "SendMessageCommand",
      I: SendMessageCommandRequest,
      O: SendMessageCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.MakeDialogReadCommand
     */
    makeDialogReadCommand: {
      name: "MakeDialogReadCommand",
      I: MakeDialogReadCommandRequest,
      O: MakeDialogReadCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.DeleteMessagesCommand
     */
    deleteMessagesCommand: {
      name: "DeleteMessagesCommand",
      I: DeleteMessagesCommandRequest,
      O: DeleteMessagesCommandResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc gdx.connections.public.v1.CommandsAPIService.RequestPhotoCommand
     */
    requestPhotoCommand: {
      name: "RequestPhotoCommand",
      I: RequestPhotoCommandRequest,
      O: RequestPhotoCommandResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

